// extracted by mini-css-extract-plugin
export default {"heading":"PageProduct_heading__Md6cY","features":"PageProduct_features__atILw","featuredItem":"PageProduct_featuredItem__SzZZB","products":"PageProduct_products__8kGCm"};